export const methods = {
    onMacroCall(name) {
        this.checked = !this.checked;
        this.$emit("onmacrocall", name);
    }
}